import * as React from 'react';
import { MobileviewSimpleLayout } from '../../../components/SimpleLayout';
import { GalleryContainer } from '../../Gallery';
import { LoadMoreButtonContainer } from '../../LoadMoreButton';
import { FullscreenGalleryContainer } from '../../FullscreenGallery';

export const MobileSimpleViewContainer: React.FC = () => {
  return (
    <>
      <MobileviewSimpleLayout gallery={<GalleryContainer />} loadMoreButton={<LoadMoreButtonContainer />} />
      <FullscreenGalleryContainer />
    </>
  );
};
